var text_field_default = {
  "root": "d7rAk",
  "text": "cMRT5",
  "input": "XXYvV",
  "small": "Bo04N",
  "medium": "YGurr",
  "large": "cDP1-",
  "webview": "hNytS",
  "endAdornment": "VewsK",
  "shown": "lKhpN",
  "value": "locIh",
  "spinner": "N2Nsx",
  "spin": "bNfvT"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
